import * as React from "react";
const SvgFiRrGif = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-gif_svg__a)">
      <path
        fill="#062147"
        d="M19 0H5a5.006 5.006 0 0 0-5 5v14a5.006 5.006 0 0 0 5 5h11.343a4.97 4.97 0 0 0 3.536-1.465l2.656-2.656A4.97 4.97 0 0 0 24 16.343V5a5.006 5.006 0 0 0-5-5M2 19V5a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v10h-4a3 3 0 0 0-3 3v4H5a3 3 0 0 1-3-3m16.465 2.121c-.402.4-.91.678-1.465.8V18a1 1 0 0 1 1-1h3.922a3 3 0 0 1-.8 1.465zM8 8.75v.334a2 2 0 0 1-2 1.984 1.99 1.99 0 0 1-2-1.984v-2.1a1.991 1.991 0 0 1 3.035-1.69c.312.19.567.462.737.785a.626.626 0 1 1-1.11.58A.78.78 0 0 0 6 6.25a.74.74 0 0 0-.749.75v2.068A.74.74 0 0 0 6 9.819a.76.76 0 0 0 .75-.735V9H6.5a.5.5 0 1 1 0-1h.75a.75.75 0 0 1 .75.75m6-.112v1.8a.624.624 0 1 1-1.25 0V5.625A.625.625 0 0 1 13.375 5h2.013a.625.625 0 1 1 0 1.25H14v1.138h1.239a.625.625 0 1 1 0 1.25zm-3-3.013v4.819a.624.624 0 1 1-1.25 0V5.625a.625.625 0 0 1 1.25 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-gif_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrGif;
